import React, { useEffect, useState, useCallback } from 'react';
import store from 'store/index';
import NumberCountUp from '../../Components/NumberCountUp';
import { fetchPriceTokenWithUSDT, setPriceWana } from 'store/actions';
import { useSelector } from 'react-redux';
import '../Farm/index.css';
import './index.css';
import { getContractAddress } from 'utils/getContractAddress';
import Staking from './staking';
import MyLockedStaking from './histories';
import styled from 'styled-components';
import { Tabs } from 'antd';
import { Link } from 'react-router-dom';
import PACKAGE_DATA, { LIST_POOL } from '__mocks__/PackageData';
import { bnum, flatten } from 'utils/helper';
import useInterval from 'utils/useInterval';
import { fetchBalanceLP, getStakedPoolV2, getAPRPoolV2 } from 'store/actions';
import { getRootUrlView } from 'utils/getContractAddress';
import LeaderBoard from './leaderBoard';
import RewardSchema from './rewardSchema';

const { TabPane } = Tabs;

const StyledBox = styled.div``;
const StyledGridStaking = styled.div`
  margin-bottom: 2rem;
  margin-top: 1rem;
`;

const StyledNote = styled.div`
  padding: 1rem 0 3rem;
  p {
    color: #dedede;
    margin: 0;
    line-height: 1.4;
    font-family: 'ChakraPetch'
  }
  p:first-child {
    font-weight: #e9e9e9;
  }
`

const Farm2 = () => {
  const { walletAddress, chainId, priceWana } = useSelector((state) => state);
  const [tab, setTab] = useState(1);
  const [packageWithData, setPackageWithDate] = useState(Object.values(PACKAGE_DATA).reduce((pre, cur) => pre.concat(cur)));
  const [tvlTotal, setTvl] = useState(bnum(0));
  const [rootUrlsView, setRootUrlsView] = useState(0);

  useEffect(() => {
    setRootUrlsView(getRootUrlView(chainId));
  }, [chainId]);

  const fetchDetailPool = useCallback(async () => {
    const packData = await Promise.all(
      LIST_POOL.map(async (pool,indexPool) => {
        const balanceLP = await store.dispatch(fetchBalanceLP(pool.contractToken));
        const APRPool = await store.dispatch(getAPRPoolV2(pool.abi, pool.contractFarm));
        PACKAGE_DATA[Object.keys(PACKAGE_DATA)[indexPool]].map((packageItem, indexPackage) =>  {
          packageItem.balanceLP = balanceLP
          if(APRPool) {
            packageItem.options.map((option, indexOption) => option.rate = bnum(APRPool[indexOption][indexPackage]).div(100).toFixed())
          }
          return packageItem
        })

        return PACKAGE_DATA[Object.keys(PACKAGE_DATA)[indexPool]];
      })
    );
    setPackageWithDate(packData.reduce((pre, cur) => pre.concat(cur)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletAddress]);

  const fetchTotalValue = useCallback(async () => {
    let totalValue = bnum(0);
    const listStakedPools = await Promise.all(LIST_POOL.map((poolPackage) => {
      return store.dispatch(getStakedPoolV2(poolPackage.abi, poolPackage.contractFarm));
    }))
    const stakedDetails = flatten(listStakedPools);
    const totalLP = stakedDetails.reduce((a, b) => Number(a) + Number(b), 0);
    const totalLPFormat = totalLP ? bnum(totalLP).div(1e18) : bnum(0);
    totalValue = totalLPFormat.plus(totalValue);
    setTvl(totalValue);
  }, []);

  useEffect(() => {
    fetchDetailPool();
  }, [fetchDetailPool]);

  useEffect(() => {
    fetchTotalValue();
  }, [fetchTotalValue]);

  useInterval(() => {
    fetchDetailPool();
    fetchTotalValue();
  }, 10000);

  useEffect(() => {
    if (chainId) {
      store
        .dispatch(fetchPriceTokenWithUSDT(getContractAddress(chainId), 18))
        .then((priceToken) => {
          store.dispatch(setPriceWana(priceToken || 0));
        });
    }
  }, [chainId]);

  const renderView = (packageWithData) => {
    if (tab === 1) {
      return <Staking packageWithData={packageWithData} rootUrlsView={rootUrlsView} fetchDetailPool={fetchDetailPool} fetchTotalValue={fetchTotalValue} />;
    } else if (tab === 2) {
      return <MyLockedStaking />;
    } else if (tab === 3) {
      return <LeaderBoard />;
    }else if (tab === 4) {
      return <RewardSchema />;
    }
  };

  const handleChangeTab = (value) => {
    setTab(+value);
  };

  return (
    <div className='staking-view background-mode'>
      <div className='container'>
        <div className='banner-stake'>
          <Link className='banner-stake--container' to='/'>
            <div className='banner-stake__right'>
              <div className='banner-stake__total-lock'>
                <div className='label'>Total Token Locked</div>
                <div className='value'>
                  <NumberCountUp
                    value={tvlTotal}
                    prefix={''}
                    decimals={0}
                  />
                </div>
              </div>
              <div className='banner-stake__price-wana'>
                <div className='label'>Price WANA</div>
                <div className='value'>
                  <NumberCountUp value={priceWana} prefix={'$'} />
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
      <div className='container'>
        <StyledGridStaking>
          <Tabs defaultActiveKey={tab} onChange={handleChangeTab} className='tabs-staking'>
            <TabPane tab='STAKING' key='1'></TabPane>
            <TabPane tab='MY LOCKED STAKING' key='2'></TabPane>
            <TabPane tab='LEADER BOARD' key='3'></TabPane>
            <TabPane tab='REWARD SCHEMA' key='4'></TabPane>
          </Tabs>

          <StyledBox>{renderView(packageWithData)}</StyledBox>
        </StyledGridStaking>
      </div>
      {(tab === 1) && <div className='container'>
        <StyledNote>
        <p>APR will decline 5% monthly compare to its previous month absolute rate. But once you decide to Stake, the current APR at that time would be applied to your contract and stay ‘fixed’ in your whole staking period.</p>
        <p>(*) The snapshot will be taken at the end of every month to do lucky draw, from July until December, 2022 </p>
        <p>(**) The snapshot will be taken at December 31st, 2022</p>
        <p>(***) Granted to the Wallet at the end of staking contract</p>
        </StyledNote>
      </div>}
    </div>
  );
};

export default Farm2;
